import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import Landing from './pages/Landing';
import AdminAuth from './pages/AdminAuth';
import AdminDashboard from './pages/AdminDashboard';
import AdminSecurity from './pages/AdminSecurity';
import AdminEditScript from './pages/AdminEditScript';
import AdminBundleEditor from './pages/AdminBundleEditor';
import AdminInterviewView from './pages/AdminInterviewView';
import ClientReview from './pages/ClientReview';
import ClientInterviewView from './pages/ClientInterviewView';
import BundleHub from './pages/BundleHub';
import BundleScriptView from './pages/BundleScriptView';
import AdminGuard from './components/AdminGuard';
import ErrorBoundary from './components/ErrorBoundary';
import './styles.css';

function AdminEditScriptRoute() {
  const { id } = useParams<{ id: string }>();
  return <AdminEditScript key={id} />;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin/setup" element={<AdminAuth mode="setup" />} />
          <Route path="/admin/login" element={<AdminAuth mode="login" />} />
          <Route
            path="/admin"
            element={
              <AdminGuard>
                <AdminDashboard />
              </AdminGuard>
            }
          />
          <Route
            path="/admin/security"
            element={
              <AdminGuard>
                <AdminSecurity />
              </AdminGuard>
            }
          />
          <Route
            path="/admin/scripts/:id"
            element={
              <AdminGuard>
                <AdminEditScriptRoute />
              </AdminGuard>
            }
          />
          <Route
            path="/admin/scripts/:id/interview"
            element={
              <AdminGuard>
                <AdminInterviewView />
              </AdminGuard>
            }
          />
          <Route
            path="/admin/links/new"
            element={
              <AdminGuard>
                <AdminBundleEditor />
              </AdminGuard>
            }
          />
          <Route
            path="/admin/links/:id"
            element={
              <AdminGuard>
                <AdminBundleEditor />
              </AdminGuard>
            }
          />
          <Route path="/s/:slug" element={<ClientReview />} />
          <Route path="/s/:slug/interview" element={<ClientInterviewView />} />
          <Route path="/b/:bundleSlug" element={<BundleHub />} />
          <Route path="/b/:bundleSlug/:slug" element={<BundleScriptView />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
);
